import { createCursorListResponseSchema, cursorPaginationInputSchema } from "./util/cursorPagination.mjs";
import { z } from "zod";
import { oc } from "@orpc/contract";
//#region src/api/orpc/contest.ts
const contestLocalesSchema = z.record(z.string(), z.record(z.string(), z.string()));
const contestSchema = z.object({
	id: z.string(),
	name: z.string(),
	mediaId: z.string(),
	thumbnailUrl: z.string().nullable(),
	startAt: z.iso.datetime(),
	endAt: z.iso.datetime(),
	cid: z.number().int(),
	published: z.boolean(),
	createdAt: z.iso.datetime(),
	updatedAt: z.iso.datetime(),
	locales: contestLocalesSchema.nullable(),
	extra: z.record(z.string(), z.unknown()).nullable()
});
const contestListInputSchema = cursorPaginationInputSchema.extend({
	published: z.stringbool().optional(),
	active: z.stringbool().optional()
});
const contestListOutputSchema = createCursorListResponseSchema(contestSchema);
const contestContract = oc.prefix("/contest").tag("Contest").router({ list: oc.route({
	summary: "List contests with pagination and filters",
	method: "GET",
	path: "/"
}).input(contestListInputSchema).output(contestListOutputSchema) });
//#endregion
export { contestContract, contestListInputSchema, contestListOutputSchema, contestSchema };
